import { Theme } from "@mui/material";
import { createBreakpoints } from "@mui/system";
import { flexGap } from "styles/flexGap";
import { transition } from "styles/transition";

const standardFontFamily = [
  "Noto Sans",
  "-apple-system",
  "BlinkMacSystemFont",
  "Arial",
  "Helvetica",
  "sans-serif",
].join(",");

const standardTypography = {
  fontFamily: standardFontFamily,
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: 1.5,
};

export const themeOverride = (theme?: Theme) => {
  return {
    breakpoints: createBreakpoints({
      values: {
        xs: 0,
        sm: 768, // iPad portrait
        md: 1024, // iPad landscape
        lg: 1280, // laptop (mackbook)
        xl: 1440, // desktop
        xxl: 1600, // desktop
        xxxl: 1920, // desktop (design)
      },
    }),

    mixins: {
      flexGap: (gap: number | string) => flexGap(gap),
      transition: (timeInSec?: number) => transition(timeInSec),
    },

    typography: {
      // Font family - based on ODL
      fontFamily: standardFontFamily,

      // Normalize typography - separate styles from semantic
      h1: {
        fontFamily: standardFontFamily,
        fontSize: "20px",
        fontWeight: 600,
      },

      h2: {
        fontFamily: standardFontFamily,
        fontSize: "18px",
        fontWeight: 600,
      },

      h3: {
        fontFamily: standardFontFamily,
        fontSize: "16px",
        fontWeight: 600,
      },

      h4: {
        fontSize: "14px",
        fontWeight: 700,
        fontFamily: standardFontFamily,
      },

      h5: {
        fontSize: "14px",
        fontWeight: 600,
        fontFamily: standardFontFamily,
      },

      h6: {
        fontSize: "12px",
        fontWeight: 700,
        fontFamily: standardFontFamily,
      },

      subtitle1: {
        fontSize: "18px",
        fontWeight: 400,
        fontFamily: standardFontFamily,
      },

      subtitle2: standardTypography,

      body1: {
        fontSize: "16px",
        fontWeight: 400,
      },

      body2: standardTypography,

      caption: {
        fontSize: "12px",
        fontWeight: 400,
      },

      htmlFontSize: 16,

      error: {
        color: theme?.palette.error?.main,
        fontSize: "1rem",
      },

      label: {
        fontWeight: "500",
      },

      italic: {
        fontStyle: "italic",
      },

      link: {
        color: theme?.palette.blue?.main,
      },
    },
  };
};
